import { Controller } from "stimulus"

// Half-day filings only make sense for a single date, so the toggle is
// disabled (and cleared) as soon as the range spans more than one day.
export default class extends Controller {
  static targets = ["startDate", "endDate", "halfDay"]

  connect() {
    this.datesChanged()
  }

  datesChanged() {
    if (!this.hasHalfDayTarget) return

    const start = this.hasStartDateTarget ? this.startDateTarget.value : ""
    const end = this.hasEndDateTarget ? this.endDateTarget.value : ""
    const singleDate = end === "" || end === start

    this.halfDayTarget.disabled = !singleDate
    if (!singleDate) this.halfDayTarget.checked = false
  }
}
